import { SuccessResponseModal } from '@/components/AppModal/modals';
import AppPageTitle from '@/components/AppPageTitle';
import AppTable from '@/components/AppTable';
import useFormSubmit from '@/hooks/useFormSubmit';
import usePaginatedQuery from '@/hooks/usePaginatedQuery';
import { getSendSmsDetail, postResendSms } from '@/services/send_sms.service';
import { formatDate } from '@/utils/formatters';
import { useMutation } from '@tanstack/react-query';
import { Button, Card, Descriptions, Flex, Modal, Space } from 'antd';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import './SendSMSDetails.scss';

function SendSMSDetails() {
  const { id } = useParams();
  const { data, isLoading } = usePaginatedQuery(
    () => getSendSmsDetail({ id }),
    ['send-sms-detail', id]
  );
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const descriptionItems = [
    {
      label: 'Title',
      children: data?.[0].title || '-',
      span: 'filled',
    },
    {
      label: 'Time',
      children: data?.[0].created_at ? formatDate(data?.[0].created_at) : '-',
      span: 'filled',
    },
    {
      label: 'Content',
      children: data?.[0].content || '-',
      span: 'filled',
    },
  ];

  const isdnListArray = data?.[0].isdn_list.split(',').map((item, index) => {
    return {
      id: index + 1,
      isdn: item,
    };
  });

  const columns = [
    {
      title: 'No.',
      key: 'id',
      dataIndex: 'id',
      width: 70,
    },
    {
      title: 'ISDN',
      key: 'isdn',
      dataIndex: 'isdn',
    },
    {
      title: 'Action',
      key: 'action',
      width: 70,
      render: (record) => {
        return (
          <Button
            // disabled={resendSmsSingleMutation.isPending}
            // loading={resendSmsSingleMutation.isPending}
            onClick={() => {
              handleOpenModalResend(
                'Confirm Resend SMS',
                `Are you sure you want to resend SMS to ${record.isdn}?`,
                () => handleResendSmsSingle(record.isdn),
                'Resend',
                'Cancel',
                resendSmsSingleMutation.isPending,
                resendSmsSingleMutation.isPending,
                false
              );
            }}
          >
            Resend
          </Button>
        );
      },
    },
  ];

  const resendSmsMutation = useMutation({
    mutationFn: postResendSms,
  });

  const resendSmsSingleMutation = useMutation({
    mutationFn: postResendSms,
  });

  const handleResendSms = useFormSubmit(
    resendSmsMutation,
    () => {
      let isdnList = [];
      if (selectedRowKeys?.length > 0) {
        selectedRowKeys.forEach((item) => {
          isdnListArray.find((isdn) => isdn.id === item && isdnList.push(isdn.isdn));
        });
      }
      const payload = {
        content: data?.[0].content,
        isdn_list: isdnList.join(','),
      };
      return payload;
    },
    {
      onSuccess: () => {
        SuccessResponseModal({
          onOk: () => {
            setSelectedRowKeys([]);
          },
        });
      },
    }
  );

  const handleResendSmsSingle = useFormSubmit(
    resendSmsSingleMutation,
    (value) => {
      const payload = {
        content: data?.[0].content,
        isdn_list: value,
      };
      return payload;
    },
    {
      onSuccess: () => {
        SuccessResponseModal({
          onOk: () => {
            setSelectedRowKeys([]);
          },
        });
      },
    }
  );

  const handleOpenModalResend = (
    title = 'Confirm Resend SMS',
    content,
    cb = () => {},
    okText = 'Resend',
    cancelText = 'Cancel',
    loading = false,
    disabled = false,
    maskClosable = false
  ) => {
    Modal.confirm({
      title: title,
      content: content,
      onOk: cb,
      okText: okText,
      cancelText: cancelText,
      okButtonProps: {
        disabled: disabled,
        loading: loading,
      },
      cancelButtonProps: {
        disabled: disabled,
      },
      maskClosable: maskClosable,
    });
  };

  return (
    <Space className="w-full" direction="vertical">
      <AppPageTitle title="Details" />
      <Card>
        <Flex vertical gap={8} align="center" justify="center">
          <Descriptions
            bordered
            items={descriptionItems}
            layout="horizontal"
            labelStyle={{
              fontWeight: 500,
            }}
            className="w-full"
          />
          <AppTable
            columns={columns}
            dataSource={isdnListArray}
            hasPagination={false}
            hasRowSelect
            rowKey="id"
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
            rowSelectionClassName="!bg-[#00000005] w-full"
            loading={isLoading}
            tableTitle={<h3 className="font-semibold">List ISDN</h3>}
            rowSelectionActionLabel={`Resend ${selectedRowKeys.length} ISDN(s)`}
            onRowSelectionAction={() => {
              handleOpenModalResend(
                'Confirm Resend SMS',
                `Are you sure you want to resend SMS to ${selectedRowKeys.length} ISDN(s)?`,
                handleResendSms,
                'Resend',
                'Cancel',
                resendSmsMutation.isPending,
                resendSmsMutation.isPending,
                false
              );
            }}
            // isRowSelectionActionLoading={resendSmsMutation.isPending}
          />
        </Flex>
      </Card>
    </Space>
  );
}

export default SendSMSDetails;
